import { useCapabilities, featureCapability } from '../../ext-core';

import { readLanguageCookie } from '../util/cookies';

/**
 * Language state for the selector (TASK175 client package):
 *
 *   { ready, enabled, languages, defaultSource, current }
 *
 * Everything entitlement-shaped comes from the tenant's capabilities block —
 * `multilanguage: { enabled, languages[], defaultSource }` served by
 * empavision through the host's capabilities proxy — so on/off + the language
 * list live in the empavision dashboard, not in marketplace code (D3).
 * `current` is the emp_lang cookie (set by the session-language endpoint),
 * falling back to the tenant's default source language.
 *
 * Fail-soft: capabilities unavailable → enabled=false → the selector renders
 * nothing.
 *
 * @param {{ rootUrl?: string }} [opts]
 */
export const useLanguages = ({ rootUrl } = {}) => {
  const { capabilities, ready } = useCapabilities({ rootUrl });
  const block = featureCapability(capabilities, 'multilanguage');

  const languages = Array.isArray(block.languages) ? block.languages : [];
  const defaultSource = block.defaultSource || 'en';
  const cookieLang = readLanguageCookie();
  const current = cookieLang && languages.includes(cookieLang) ? cookieLang : defaultSource;

  return {
    ready,
    enabled: !!block.enabled && languages.length > 0,
    languages,
    defaultSource,
    current,
  };
};
